import { ImageIcon, EyeOff } from "lucide-react";
import Image from "next/image";

type ImagePreviewProps = {
  imageUrl?: string | null;
  altText?: string | null;
  label: string;
  /** Whether images are present (for multi-image uploads) */
  hasImages?: boolean;
};

/**
 * Image preview component with fallback for empty state
 *
 * Shows either the uploaded image or an appropriate icon placeholder:
 * - ImageIcon when images are present but no specific image is shown
 * - EyeOff when no images are present at all
 * Handles proper aspect ratio and centering.
 */
export function ImagePreview({
  imageUrl,
  altText,
  label,
  hasImages = false,
}: ImagePreviewProps) {
  return (
    <div className="relative h-full w-[90px] shrink-0 border-r object-contain p-2">
      <div className="relative flex h-full items-center justify-center overflow-hidden">
        {imageUrl ? (
          <Image
            src={imageUrl}
            alt={altText || label}
            className="max-h-full max-w-full object-contain"
            width={50}
            height={50}
          />
        ) : hasImages ? (
          <ImageIcon size={32} className="text-gray-400" />
        ) : (
          <EyeOff size={32} className="text-gray-400" />
        )}
      </div>
    </div>
  );
}
